"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkedinCreatePost = exports.linkedinCreatePostResultSchema = exports.linkedinCreatePostArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Text post parameters
var textPostParamsSchema = zod_1.z.object({
    visibility: zod_1.z
        .enum(['PUBLIC', 'CONNECTIONS', 'LOGGED_IN'])
        .describe('Visibility restrictions on content. Can be PUBLIC, CONNECTIONS, or LOGGED_IN.')
        .default('PUBLIC'),
    text: zod_1.z.string().describe('Text to be posted on LinkedIn timeline'),
    article: zod_1.z.string().url().nullish().describe('The URL of an article to share'),
});
// Image post parameters
var imagePostParamsSchema = zod_1.z.object({
    visibility: zod_1.z
        .enum(['PUBLIC', 'CONNECTIONS', 'LOGGED_IN'])
        .describe('Visibility restrictions on content. Can be PUBLIC, CONNECTIONS, or LOGGED_IN.')
        .default('PUBLIC'),
    text: zod_1.z.string().describe('Text to be posted on LinkedIn timeline'),
    imageUrl: zod_1.z.string().url().describe('The URL of the image file to post'),
});
// Discriminated union for post types
exports.linkedinCreatePostArgsSchema = zod_1.z.discriminatedUnion('postType', [
    zod_1.z.object({
        postType: zod_1.z.literal('text'),
        params: textPostParamsSchema,
    }),
    zod_1.z.object({
        postType: zod_1.z.literal('image'),
        params: imagePostParamsSchema,
    }),
]);
// Result schema (same for both post types)
exports.linkedinCreatePostResultSchema = zod_1.z.object({
    summary: zod_1.z.string().describe('A summary of the action success or failure'),
    recentActivityUrl: zod_1.z.string().describe("A link to the user's recent activity"),
});
// Tool metadata
exports.linkedinCreatePost = (0, common_1.createToolMetadata)({
    id: 'linkedinCreatePost',
    displayName: 'LinkedIn Create Post',
    displayDescription: 'Create a text or image post on LinkedIn as the user',
    category: 'social',
    color: common_1.BRAND_COLORS.LINKEDIN,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.LINKEDIN),
    icon: 'linkedin',
    argsSchema: exports.linkedinCreatePostArgsSchema,
}, exports.linkedinCreatePostResultSchema);
